import { institutionConstants, institutionFEPConstants, institutionDropdownConstants, nameSpace, name_space, nameFepSpace } from "../constants/institution.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null,

  dropdown_loading: false,
  dropdown_success: false,
  dropdown_request: null,
  dropdown_response: null,
  dropdown_error: null,

  fep_loading: false,
  fep_success: false,
  fep_request: null,
  fep_response: null,
  fep_error: null
};

export const getInstitution = (state = initialState, action) => {
  switch (action.type) {
    case institutionConstants[`GET_${nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case institutionConstants[`GET_${nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response && action.response,
        error: null
      };
    case institutionConstants[`GET_${nameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };

    case institutionFEPConstants[`GET_${nameFepSpace}_REQUEST`]:
      return {
        ...state,
        fep_loading: true,
        fep_request: action.request
      };
    case institutionFEPConstants[`GET_${nameFepSpace}_SUCCESS`]:
      return {
        ...state,
        fep_loading: false,
        fep_success: true,
        fep_response: action.response && action.response,
        fep_error: null
      };
    case institutionFEPConstants[`GET_${nameFepSpace}_FAILURE`]:
      return {
        ...state,
        fep_loading: false,
        fep_success: false,
        fep_error: action.error
      };

    case institutionDropdownConstants[`GET_${name_space}_REQUEST`]:
      return {
        ...state,
        dropdown_loading: true,
        dropdown_request: action.request
      };
    case institutionDropdownConstants[`GET_${name_space}_SUCCESS`]:
      return {
        ...state,
        dropdown_loading: false,
        dropdown_success: true,
        dropdown_response: action.response && action.response,
        dropdown_error: null
      };
    case institutionDropdownConstants[`GET_${name_space}_FAILURE`]:
      return {
        ...state,
        dropdown_loading: false,
        dropdown_success: false,
        dropdown_error: action.error
      };
    default:
      return state;
  }
};
